import React from "react"
import CustomModal from "../basics/interface/CustomModal"
import { generalStyles } from "../styles/styles"

// Confirmation d'activation / désactivation du mode assurance (extrait d'AtelierV2).
const AtelierSwitchAssuranceModalV2 = ({
	isAssurance,
	selectedAssurance,
	onSelectAssurance,
	assurances,
	onConfirm,
	onClose,
}) => (
	<CustomModal
		title={
			isAssurance
				? "Désactiver le mode assurance ?"
				: "Activer le mode assurance"
		}
		subtitle={
			isAssurance
				? "Les informations assurance seront effacées et les tarifs de main d'œuvre recalculés."
				: "Choisissez l'assurance ; les tarifs de main d'œuvre seront recalculés."
		}
		onClose={onClose}
		showCloseButton={false}
		buttons={[
			{ title: "Annuler", styleName: "secondary", onClick: onClose },
			{ title: "Confirmer", styleName: "primary", onClick: onConfirm },
		]}
	>
		{!isAssurance && (
			<div style={generalStyles.fieldRow}>
				<span style={generalStyles.label}>Assurance</span>
				<select
					style={generalStyles.select}
					value={selectedAssurance}
					onChange={(e) => onSelectAssurance(parseInt(e.target.value))}
				>
					<option value={0}>-</option>
					{assurances.map((ass) => (
						<option key={`swass_${ass.id}`} value={ass.id}>
							{ass.label}
						</option>
					))}
				</select>
			</div>
		)}
	</CustomModal>
)

export default AtelierSwitchAssuranceModalV2
